import { useState } from "react";

export const useShowServiceModal = () => {
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  const handleShowServiceModal = (service) => {
    setSelectedService(service);
    setShowServiceModal(true);
  };

  const handleCloseServiceModal = () => {
    setSelectedService(null);
    setShowServiceModal(false);
  };

  return {
    showServiceModal,
    selectedService,
    handleShowServiceModal,
    handleCloseServiceModal,
  };
};
